"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Set a path in a given object, each parent that doesn't already exist is auto created
 * @param path
 * @param val
 * @param obj
 */
exports.default = (path, val, obj) => {
    const keys = path.split('.');
    const lastKey = keys.pop();
    const lastObj = keys.reduce((obj, key) => obj[key] = obj[key] || {}, obj);
    lastObj[lastKey] = val;
};
